import "../../assets/css/sponsor-badge.css";
import Panel from "../Panel/Panel";
import { wrapAuthData } from "../AuthData/AuthData";
import { mapChildData } from "../../helpers/helpers";
import dayjs from "dayjs";
import Ribbon from "../Icons/Ribbon";
const shimmerProps = {height: "120px"};
const requires = ["commitment", "child"];

export function SponsorBadge(props) {
  const { requiredData } = props;
  const { child, commitment } = requiredData;
  const mappedChildData = mapChildData(child);
  const { name } = mappedChildData;
  const startDate = commitment?.CommitmentDetailStartDate;

  if (!startDate) {
    // TODO: Log This Scenario
    return null;
  }

  const monthYearDisplay = dayjs(startDate).format("MMMM YYYY");
  const yearsSponsored = dayjs().diff(startDate, 'year');
  const sponsoredLessThanYear = yearsSponsored < 1;

  if (sponsoredLessThanYear) {
    return null;
  }

  return (
    <Panel classList="panel__sponsor-badge">
      <div className="sponsor-badge__content">
        <p className="eta">You have sponsored {name} for <strong className="sponsor-badge__content--highlight __highlighter">{yearsSponsored} years!</strong></p>
        <p>Since {monthYearDisplay}</p>
      </div>

      <div className="sponsor-badge__ribbon">
        <Ribbon>{yearsSponsored}</Ribbon>
      </div>
    </Panel>
  );
}

export default wrapAuthData(SponsorBadge, {shimmerProps, requires, name: "SponsorBadge"});